module.exports = __webpack_public_path__ + "images/emoji/trident.228e8a368d4c82fa7c3a.png";